import { useStore } from '../store/StoreContext.jsx';
import Field from './Field.jsx';

// `lockHint`, when given, locks the toggle: the block shows or stays closed as
// the data says, and the button explains where that is decided instead.
export default function ConditionalBlock({ block, sectionId, onToggleOff, children, headerSlot, lockHint }) {
  const { data, update } = useStore();
  const flag = !!data?._flags?.[block.flag];

  const toggle = () => {
    if (lockHint) return;
    const next = !flag;
    update(`_flags.${block.flag}`, next);
    if (!next && onToggleOff) onToggleOff();
  };

  const button = (
    <button
      type="button"
      className="btn btn-light btn-sm"
      onClick={toggle}
      disabled={!!lockHint}
      title={lockHint || undefined}
    >
      {flag ? block.hideLabel : block.toggleLabel}
    </button>
  );

  if (headerSlot) {
    return headerSlot({ flag, button, content: flag ? children : null });
  }

  // One toggle that stays put and just swaps its label — the Hide button sits
  // exactly where the Add button was (top-left), instead of jumping to a
  // centered divider when the block opens.
  return (
    <div className="conditional-block">
      <button
        type="button"
        className="conditional-block-toggle"
        style={flag ? { marginBottom: 12 } : undefined}
        onClick={toggle}
      >
        {flag ? block.hideLabel : block.toggleLabel}
      </button>
      {flag && children}
    </div>
  );
}
